import { Ref, ref } from "vue";

export const useDraggable = (
  root: Ref<HTMLElement | undefined>,
  tempPos: Ref<{ x: number; y: number }>,
  moveObject: (x: number, y: number) => void
) => {
  const startPos = ref<{
    x: number;
    y: number;
    orgX: number;
    orgY: number;
  }>();
  let isMoving = false;
  // 親要素を取得
  const getParent = () => {
    if (root.value === undefined) {
      return undefined;
    } else if (root.value.parentElement == null) {
      return undefined;
    }
    return root.value.parentElement;
  };
  // オリジナルの座標とサイズを取得
  const getOriginalRect = (elm: HTMLElement) => {
    const x = elm.offsetLeft;
    const y = elm.offsetTop;
    const width = elm.clientWidth;
    const height = elm.clientHeight;
    return {
      x: x,
      y: y,
      width: width,
      height: height,
    };
  };
  const getChildBounds = () => {
    if (root.value === undefined) {
      return undefined;
    }
    const transformRect = getOriginalRect(root.value);
    if (transformRect === undefined) return;
    return transformRect;
  };
  const toRelativePos = (x: number, y: number) => {
    // parentからの相対座標に変換
    const rect = getParent()?.getBoundingClientRect();
    const pos = {
      x: x - (rect?.left ?? 0),
      y: y - (rect?.top ?? 0),
    };
    return pos;
  };
  // ドラッグ動作開始
  const pointerdown = (e: PointerEvent) => {
    const pos = toRelativePos(e.clientX, e.clientY);
    const elPos = getChildBounds();
    if (elPos === undefined) {
      return;
    }
    if (root.value === undefined) {
      return;
    }
    startPos.value = {
      x: pos.x,
      y: pos.y,
      orgX: elPos.x,
      orgY: elPos.y,
    };
    // マウスをキャプチャ
    root.value.setPointerCapture(e.pointerId);
    self.onpointermove = pointermove;
    isMoving = false;
  };
  // ドラッグ動作終了
  const pointerup = (e: PointerEvent) => {
    startPos.value = undefined;
    if (root.value === undefined || !isMoving) {
      return;
    }
    root.value.releasePointerCapture(e.pointerId);
    self.onpointermove = null;
    // 移動量を確定
    moveObject(tempPos.value.x, tempPos.value.y);
  };
  const THRESHOLD = 5;
  // 要素を指定の位置へ移動させる
  const pointermove = (e: PointerEvent) => {
    if (startPos.value === undefined) return;
    const pos = toRelativePos(e.clientX, e.clientY);
    if (
      Math.abs(startPos.value.x - pos.x) < THRESHOLD &&
      Math.abs(startPos.value.y - pos.y) < THRESHOLD
    )
      return;

    isMoving = true;
    const x = startPos.value.orgX + (pos.x - startPos.value.x);
    const y = startPos.value.orgY + (pos.y - startPos.value.y);
    move(x, y);
  };
  const move = (x: number, y: number) => {
    // const parent = getParent();
    // if (parent === undefined) {
    //   return;
    // }
    // if (root.value === undefined) {
    //   return;
    // }
    // const elPos = getChildBounds();
    // if (elPos === undefined) {
    //   return;
    // }
    // const minX = 0;
    // const minY = 0;
    // const maxX = minX + parent.getBoundingClientRect().width;
    // const maxY = minY + parent.getBoundingClientRect().height;
    // if (x < minX) {
    //   x = minX;
    // }
    // if (maxX < x + elPos.width) {
    //   x = maxX - elPos.width;
    // }
    // if (y < minY) {
    //   y = minY;
    // }
    // if (maxY < y + elPos.height) {
    //   y = maxY - elPos.height;
    // }
    tempPos.value = {
      x: x,
      y: y,
    };
  };
  return {
    pointerdown,
    pointerup,
  };
};
